import useCurrentUser from "./useCurrentUser";

export default function useAccessLevel() {
    const { accesslevel=null } = useCurrentUser() || {};
    return accesslevel;
}